import { render, staticRenderFns } from "./FaxContactInfo.vue?vue&type=template&id=66c94393"
import script from "./FaxContactInfo.vue?vue&type=script&lang=ts"
export * from "./FaxContactInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports